import { useTranslation } from "react-i18next";

import { MainLayout } from "components/layouts";
import WelfareFrom from "../components/WelfareFrom";

import styles from "../styles/Welfare.module.css";
import { Breadcrumb, ConfigProvider, Flex, Space, Tabs } from "antd";
import WelfareWorkflow from "./WelfareWorkflow";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const WelfareEdit = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [selectedKeys, setSelectedKeys] = useState(["welfare_detail"]);
  const onMenuClick = (e) => {
    const key = e.key;
    setSelectedKeys([key]);
    // onChange(key);
  };

  return (
    <MainLayout>
      <Space direction="vertical" style={{ width: "100%" }} size={24}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("configuration.header"), href: "/configuration/payroll" },
            { title: t("payroll_setting.header"), href: "/configuration/payroll" },
            {
              title: t("welfare.header"), href: "/configuration/payroll",
              onClick: (e) => {
                e.preventDefault();
                navigate("/configuration/payroll", { state: { selectedTab: 'welfare' } });
              }
            },
            { title: t("common.edit") }
          ]} />
          <h2>{t("common.edit")}</h2>
        </Flex>
        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                itemHoverColor: "var(--tab-color)",
                itemActiveColor: "var(--tab-color)"
              },
            },
          }}
        >
          <Tabs destroyInactiveTabPane={true} defaultActiveKey={selectedKeys} onChange={onMenuClick}>
            <Tabs.TabPane tab={t("welfare.label.welfare_detail")} key="welfare_detail">
              <WelfareFrom {...props} />
            </Tabs.TabPane>

            <Tabs.TabPane tab={t("workflow.header")} key="welfare_workflow">
              <WelfareWorkflow />
            </Tabs.TabPane>
          </Tabs>
        </ConfigProvider>
      </Space>
    </MainLayout>
  );
};

export default WelfareEdit;
